// ----------------------------------------------------------------------

export default function Dialog(theme) {
  return {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          '& + .MuiDialogContent-root': {
            paddingTop: `${theme.spacing(4)} !important`,
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(4),
        },
      },
    },
  };
}
